import type { LiveUpdateDto } from "@oshimap/schemas";

/**
 * 대기 시간 표기.
 *
 * **절대 줄여 말하지 않는다.** 90분을 "1시간" 이라고 쓰면 한 시간만 기다리면
 * 될 줄 알고 간 사람이 30분을 더 서 있게 된다 — 헛걸음보다 나쁠 수도 있다.
 */
export function formatWait(minutes: number): string {
  if (minutes <= 0) return "바로 입장";
  if (minutes < 60) return `${minutes}분`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h}시간` : `${h}시간 ${m}분`;
}

/** 유형마다 값의 모양이 다르다 (실측). 아는 것만 읽고 모르는 건 건너뛴다. */
export function liveDetail(u: Pick<LiveUpdateDto, "type" | "value">): string {
  const v = (u.value ?? {}) as Record<string, unknown>;
  if (u.type === "WAIT_TIME") {
    return typeof v["minutes"] === "number" ? formatWait(v["minutes"] as number) : "";
  }
  const s = (k: string) => (typeof v[k] === "string" ? (v[k] as string) : null);
  return s("itemName") ?? s("benefitName") ?? s("note") ?? s("sessionLabel") ?? "";
}
